<template>
  <span style="padding-left:6px;">
    <a-avatar :src="image" icon="user" size="large" shape="square" @click="selectFile" />
    <a-spin  :spinning="spinning" size="small" :style="{position:'relative',left:'-10px',width:'80px'}"></a-spin>
    <input type="file" id="file" 	@change="handleUpload" hidden />
  </span>
 </template>
<script>
import { getFastDFSToken, saveFileUrl } from '@/api/file'
import { editUserAvatar } from '@/api/user'
import { axios } from '@/utils/request'

export default {
  name: 'AvatarEdit',
  props: {
    src: {
      type: String,
      default: '@/assets/user.svg'
    }
  },
 
  data () {
    return {
      FDStoken: '',
      spinning: false,
      image:'',
    }
  },
  watch:{
    src(val){
      if(val='')this.image=null
      else this.image = val
    }
  },
  created () {
    this.image = this.src
    const _this = this
    getFastDFSToken().then(res => {
      _this.FDStoken = res.token
      //
    })
  },
  mounted(){ },
  methods: {
    selectFile(){
      if(this.spinning)return
      document.getElementById('file').click()
    },
    handleUpload () {
      this.spinning = true
      var image = document.getElementById('file').files[0]
      const formData = new FormData()
      const _this = this

      formData.append('file', image)
      formData.append('fastdfs_token', this.FDStoken)

      axios({
        method: 'post',
        url: '/fastdfs/upload',
        data: formData,
        timeout: 1000 * 60 * 2
      }).then(res => {
        const url = res.data.fileurl
        editUserAvatar({user_avatar:url}).then(res=>{
          if(res.code != 200) throw ""
          _this.image = url
          _this.$store.commit('SET_AVATAR', url )
          _this.$store.commit('UPDATE_INFO', {
            key:'user_avatar',
            value: url
          })
          _this.spinning = false
          _this.$emit('avatar_changed')
        }).catch(err=>{
          _this.spinning = false
          _this.$message.error('修改头像失败')
        })
      }).catch(err => {
        _this.spinning = false
        _this.$message.error('修改头像失败')
      })
    }

  }
}
</script>
